import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { ManufacturerService, Product, ProductService } from 'octali-lib-shop';
import { SortPipe } from 'octali-lib-utils';
import { combineLatest, Subscription } from 'rxjs';
import { ProductsListPanelViewComponent } from 'src/app/components/product/products-list-panel-view/products-list-panel-view.component';
import { createDeflate } from 'zlib';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage implements OnInit, OnDestroy {

  @ViewChild('productsList', { read: ProductsListPanelViewComponent, static: true }) productsList: ProductsListPanelViewComponent;
  public products:Array<Product>;
  private subscription:Subscription;
  constructor(
    private platform:Platform,
    private productService: ProductService,
    private manufacturerService: ManufacturerService,
    private navCtrl: NavController
  ) {
    
  }

  ngOnDestroy(): void {
    this.unscribe();
  }
  
  ngOnInit(): void {
    
  }

  ionViewWillEnter() {
    this.subscription = this.productService.getProductsByStatutObs().subscribe( (products) => {
      if( products ){
        this.products = products.get("publish");
        let st:SortPipe = new SortPipe();
        st.transform(this.products,{property:"createdAt",order:1});
        this.productsList.setProducts( this.products.slice(0,8) );
      }
    });
  }

  unscribe() {
    if( this.subscription )
      this.subscription.unsubscribe();
  }

  select( prod ){
    let manId = this.manufacturerService.getManufacturersIdObs().getValue();
    let title = prod.title.replace(/\/|\s/g, "-").toLowerCase();
    console.log(title,prod.title);

    if (manId.has(prod.manufacturer) && manId.get(prod.manufacturer).name != "" ){
      let man = manId.get(prod.manufacturer).name.replace(/\/|\s/g, "-").toLowerCase();
      this.navCtrl.navigateRoot("/produits/"+encodeURI(man)+"/"+encodeURI(title)+"/"+prod.id);
    }else
    if(title != "")
      this.navCtrl.navigateRoot("/produits/"+encodeURI(prod.title)+"/"+prod.id);
  }
}
